import { render } from "./ImgRemarkDialog.vue?vue&type=template&id=2d47baa0&scoped=true"
import script from "./ImgRemarkDialog.vue?vue&type=script&lang=js"
export * from "./ImgRemarkDialog.vue?vue&type=script&lang=js"

import "./ImgRemarkDialog.vue?vue&type=style&index=0&id=2d47baa0&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d47baa0"]])

export default __exports__